import { JSON2CSVType } from './interfaces'

export const JSON2CSV = ({ jsonData, exclude }: JSON2CSVType) => {
  if (typeof jsonData === 'object' && jsonData.length && jsonData.length > 0) {
    const header = Object.keys(jsonData[0]).filter((title) => title !== exclude)
    const body = jsonData.map((row: { [index: string]: any } = {}) =>
      header.map((fieldName) => `${row[fieldName]}`.replace(',', ' ')).join(',')
    )
    return `${[header.join(','), ...body].join('\n')}`
  } else {
    return '[]'
  }
}
